import React from 'react';
import { ExpansionPanel, ExpansionPanelContent, ExpansionPanelTrigger } from '@eventbrite/marmalade';
import type { FAQ } from '../../types';
import styles from './FAQItem.module.scss';

interface FAQItemProps {
  faq: FAQ;
}

export const FAQItem: React.FC<FAQItemProps> = ({ faq }) => {
  if (!faq.question?.trim() || !faq.answer?.trim()) {
    return null;
  }

  return (
    // @ts-expect-error: TS2739
    <ExpansionPanel className={styles.faqItem}>
      {/* @ts-expect-error: TS2739 */}
      <ExpansionPanelTrigger className={styles.question}>{faq.question}</ExpansionPanelTrigger>
      {/* @ts-expect-error: TS2739 */}
      <ExpansionPanelContent>
        <div className={styles.answer}>{faq.answer}</div>
      </ExpansionPanelContent>
    </ExpansionPanel>
  );
};
